import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, App, Tab, ActionSheetController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { CalanderPage } from '../calander/calander';
import { LoginPage } from '../login/login';
import { ReportsPage } from '../reports/reports';
import { AdminPage } from '../admin/admin';
import { EventsPage } from '../events/events';
import { AdminNextPage } from '../admin-next/admin-next';
import { PostLogin, Sevacategorty } from '../../models/PostLogin';
import { User, Categories } from '../../models/User';
import { ProfilePage } from '../profile/profile';
import { PagesExpenditurePage } from '../pages-expenditure/pages-expenditure';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage implements OnInit{
 user:PostLogin;
 userdata:User;
 username:string;
 show:boolean = false;
 categories:Sevacategorty[] = [];
 user_role:number;
  constructor(public navCtrl: NavController, public navParams: NavParams,private alertController:AlertController,public appCtrl: App,public actionSheetCtrl: ActionSheetController) {
    this.initializeParams()

  }
tab1Root = CalanderPage;
tab2Root = EventsPage;
tab3Root = ReportsPage;
tab4Root = AdminNextPage;
tab5Root = TabsPage;
voucherRoot = PagesExpenditurePage;
tab1params:any;
initializeParams()
{
this.tab1params = { user:this.categories};
}
ngOnInit()
{
this.user = this.navParams.get('user');

//this.categories = this.user.svacategory;
console.log("sevacategories:",this.categories);
if(this.user)
{
  this.userdata = this.user.user;
  this.username = this.userdata.name;
  this.username = this.username.toUpperCase();
  console.log("user_role in tabs page" ,this.userdata.user_role)
  this.user_role = this.userdata.user_role;

  
  console.log("username in tabs page:",this.username)
  
  console.log("user",this.userdata)
  
  this.tab1params = {user:this.categories}
}

}
tabSelected(tab: Tab) {
  console.log(tab.index);
  console.log(tab.tabTitle)
  if(tab.tabTitle != "BILLING" && tab.tabTitle != "REPORTS" && tab.tabTitle != "EVENTS" && tab.tabTitle != "ADMIN" && tab.tabTitle != "EXPENDITURE")
  //if(tab.index == 4)
  {
    this.show = true;
    //this.Logout();
    //this.ShowUserOptions();

  }
  else
  {
     this.show = false;
  }

}
hideList()
{
  console.log("came")
  this.show = false;
}
 //Function for log out
 Logout() {
  this.show = false;
   console.log("logout clicked")
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Are you sure you want to Logout?',
    cssClass: 'buttonCss',
    buttons: [
      {
        text: 'No',
        cssClass: 'buttonCss',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      },
      {
        text: 'Yes',
        cssClass: 'buttonCss',
        handler: () => {
          console.log('Yes clicked');
          // if (localStorage.getItem('token')) {
          //   localStorage.removeItem('token');
          // }
         
          //clearing all local storage data
          localStorage.clear();
          this.appCtrl.getRootNav().setRoot(LoginPage);
        }
      }
    ]
  });

  alert.present();

}
ShowUserOptions()
{
  this.show = false;
  this.navCtrl.push(ProfilePage,{user:this.userdata,logindata:this.user});
  // const actionSheet = this.actionSheetCtrl.create({
  //   title: 'Please select your option',
  //   buttons: [
  //     {
  //       text: 'Profile',
  //       handler: () => {
  //         //console.log(' clicked');
  //          console.log("userdata to profile page",this.userdata)
  //         this.navCtrl.push(ProfilePage,{user:this.userdata,logindata:this.user});

  //       }
  //     },{
  //       text: 'Logout',
  //       handler: () => {
  //         console.log('Archive clicked');
  //         this.Logout();
  //       }
  //     }
  //   ]
  // });
  // actionSheet.present();
//   document.getElementById("yourdivid").onblur = function() {
//     alert('blur');
    
//  }
//  window.onload = function(){
//   var divToHide = document.getElementById('divToHide');
//   document.onclick = function(e){
//     if(e.target.id !== 'divToHide'){
//       //element clicked wasn't the div; hide the div
//       divToHide.style.display = 'none';
//     }
//   };
// };
}

 callme()
 {
   console.log("clikkk")
 }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts